import { toLocaleStringSupportsLocales } from './toLocaleStringSupportsLocales';
var intlNumberFormatterMap = new Map();
export function getLocNumberString(num, preferredCulture) {
    var formatter;
    if (!intlNumberFormatterMap.has(preferredCulture)) {
        try {
            if ('Intl' in window) {
                formatter = new Intl.NumberFormat(preferredCulture);
            }
        }
        catch (e) { }
        intlNumberFormatterMap.set(preferredCulture, formatter);
    }
    else {
        formatter = intlNumberFormatterMap.get(preferredCulture);
    }
    if (formatter) {
        return formatter.format(num);
    }
    if (toLocaleStringSupportsLocales) {
        try {
            return num.toLocaleString(preferredCulture);
        }
        catch (_a) { }
    }
    return num.toString();
}
//# sourceMappingURL=getLocNumberString.js.map